module.exports = __webpack_public_path__ + "static/compliance-0f75e122952a509753e20631ee9c8149.svg";